"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ = require('lodash');
var parseQueryString = function parseQueryString(queryString) {
  var params = {},
    queries,
    temp,
    i,
    l;
  // Split into key/value pairs
  queries = queryString.replace('?', '').split("&");
  // Convert the array of strings into an object
  for (i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split('=');
    params[temp[0]] = temp[1];
  }
  return params;
};
exports.parseQueryString = parseQueryString;
var getQueryString = function getQueryString(searchKeys) {
  return _.reduce(searchKeys, function (str, val, key) {
    if (!val) {
      return str;
    } else if (str.length <= 0) {
      return key + '=' + val;
    } else {
      return str + '&' + key + '=' + val;
    }
  }, '');
};
exports.getQueryString = getQueryString;
var urlHashToObject = function urlHashToObject() {
  if ('object' !== (typeof location === "undefined" ? "undefined" : _typeof(location))) {
    console.log('Called fn urlHashToObject with window.location out of scope. Returned empty.');
    return {};
  }
  var cleanHash = location.hash.split('?')[0];
  var hashValue = cleanHash.slice(1);
  var whatsInHash = hashValue.split('&');
  var returnObj = {};
  _.forEach(whatsInHash, function (value) {
    var hashBlock = value.split('=');
    returnObj[hashBlock[0]] = hashBlock[1];
  });
  return returnObj;
};
exports.urlHashToObject = urlHashToObject;